import React from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon, ClockIcon } from 'lucide-react';
import { Divider } from './ui/Divider';
interface Service {
  name: string;
  duration: string;
  price: string;
}
const services: Service[] = [{
  name: 'Regular Haircut',
  duration: '30min',
  price: '$30'
}, {
  name: 'Haircut + Beard',
  duration: '45min',
  price: '$40'
}, {
  name: 'Regular Cut + Eyebrows',
  duration: '45min',
  price: '$35'
}, {
  name: 'Regular Cut + Eyebrows + Beard',
  duration: '45min',
  price: '$45'
}, {
  name: 'Haircut + Eyebrows + Beard',
  duration: '1h',
  price: '$50'
}, {
  name: 'Haircut + Eyebrows + Beard + Design',
  duration: '1h',
  price: '$100'
}, {
  name: 'Hot Towel Shave',
  duration: '30min',
  price: '$25'
}, {
  name: 'Beard Trim',
  duration: '15min',
  price: '$15'
}, {
  name: 'Eyebrows',
  duration: '15min',
  price: '$10'
}, {
  name: 'Fades',
  duration: '30min',
  price: '$30'
}, {
  name: 'Shape Up',
  duration: '15min',
  price: '$15'
}, {
  name: 'Shampoo',
  duration: '15min',
  price: '$10'
}, {
  name: 'Designs',
  duration: '15min',
  price: '$10'
}, {
  name: 'Senior Citizens (62+)',
  duration: '30min',
  price: '$25'
}, {
  name: 'Kids (10 & Under)',
  duration: '30min',
  price: '$25'
}, {
  name: 'Nose Wax',
  duration: '15min',
  price: '$10'
}, {
  name: 'Ear Wax',
  duration: '15min',
  price: '$10'
}];
export function ServicesSection() {
  return <section id="servicios" className="bg-delux-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-291">
      <div className="max-w-6xl mx-auto" data-id="element-292">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-293">
          <ScissorsIcon className="w-10 h-10 text-delux-gold mx-auto mb-6" data-id="element-294" />
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-4" data-id="element-295">
            Nuestros Servicios
          </h2>
          <p className="font-body text-lg text-delux-body max-w-2xl mx-auto" data-id="element-296">
            Cada servicio incluye una experiencia premium. Elige el tuyo.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-id="element-297">
          {services.map((service, index) => <motion.div key={service.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.04,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="group relative bg-delux-card border border-delux-gold/15 rounded-xl p-5 flex flex-col justify-between min-h-[140px] hover:border-delux-gold/40 transition-colors duration-300" data-id="element-298">
              {/* Service name */}
              <div data-id="element-299">
                <h3 className="font-heading text-sm md:text-base text-delux-white leading-snug mb-2" data-id="element-300">
                  {service.name}
                </h3>
                <div className="flex items-center gap-1.5 text-delux-body/60" data-id="element-301">
                  <ClockIcon className="w-3.5 h-3.5" data-id="element-302" />
                  <span className="font-body text-xs md:text-sm" data-id="element-303">
                    {service.duration}
                  </span>
                </div>
              </div>

              {/* Price */}
              <div className="mt-4 self-end" data-id="element-304">
                <span className="inline-block bg-delux-gold/10 border border-delux-gold/20 text-delux-gold font-heading font-bold text-sm md:text-base px-3 py-1 rounded-lg group-hover:bg-delux-gold/20 transition-colors duration-300" data-id="element-305">
                  {service.price}
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* CTA below services */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center mt-12" data-id="element-306">
          <a href="#contacto" className="inline-block bg-delux-gold hover:bg-delux-gold-light text-delux-bg px-8 py-4 rounded font-heading font-bold text-lg tracking-wide transition-all duration-300 hover:shadow-[0_0_20px_rgba(200,164,90,0.5)] transform hover:-translate-y-1" data-id="element-307">
            Reserva Tu Cita Ahora
          </a>
        </motion.div>
      </div>
      <Divider data-id="element-308" />
    </section>;
}